const ExtMap = {
    'default': {
        IconName: 'insert_drive_file'
    },
    // Audio
    'aif': { IconName: 'i-FT-MP3ARC' },
    'cda': { IconName: 'i-FT-MP3ARC' },
    'mid': { IconName: 'i-FT-MP3ARC' },
    'mp3': { IconName: 'i-FT-MP3ARC' },
    'mpa': { IconName: 'i-FT-MP3ARC' },
    'ogg': { IconName: 'i-FT-MP3ARC' },
    'wav': { IconName: 'i-FT-MP3ARC' },
    'wma': { IconName: 'i-FT-MP3ARC' },
    'wpl': { IconName: 'i-FT-MP3ARC' },

    // Archieve
    '7z': { IconName: 'i-FT-ZIPARC' },
    'arj': { IconName: 'i-FT-ZIPARC' },
    'deb': { IconName: 'i-FT-ZIPARC' },
    'pkg': { IconName: 'i-FT-ZIPARC' },
    'rar': { IconName: 'i-FT-ZIPARC' },
    'rpm': { IconName: 'i-FT-ZIPARC' },
    'tar.gz': { IconName: 'i-FT-ZIPARC' },
    'z': { IconName: 'i-FT-ZIPARC' },
    'zip': { IconName: 'i-FT-ZIPARC' },

    // Photo
    'ai': { IconName: 'i-image' },
    'bmp': { IconName: 'i-image' },
    'gif': { IconName: 'i-image' },
    'ico': { IconName: 'i-image' },
    'jpeg': { IconName: 'i-FT-JPGARC' },
    'jpg': { IconName: 'i-FT-JPGARC' },
    'png': { IconName: 'i-FT-PNGARC' },
    'ps': { IconName: 'i-image' },
    'psd': { IconName: 'i-image' },
    'svg': { IconName: 'i-image' },
    'tif': { IconName: 'i-image' },


    // Spreadsheet
    'xlr': { IconName: 'i-FT-XLSARC' },
    'ods': { IconName: 'i-FT-XLSARC' },
    'xls': { IconName: 'i-FT-XLSARC' },
    'xlsx': { IconName: 'i-FT-XLSARC' },

    // Document
    'pdf': { IconName: 'i-FT-PDFARC' },
    'doc': { IconName: 'i-FT-DOCARC' },
    'docx': { IconName: 'i-FT-DOCARC' },
    'odt': { IconName: 'i-FT-DOCARC' },
    'rtf': { IconName: 'i-FT-DOCARC' },
    'tex': { IconName: 'i-FT-DOCARC' },
    'txt': { IconName: 'i-FT-TXTARC' },
    'wks': { IconName: 'i-FT-DOCARC' },
    'wps': { IconName: 'i-FT-DOCARC' },
    'wpd': { IconName: 'i-FT-DOCARC' },

    // Video
    '3g2': { IconName: 'i-FT-MP4ARC' },
    '3gp': { IconName: 'i-FT-MP4ARC' },
    'avi': { IconName: 'i-FT-MP4ARC' },
    'flv': { IconName: 'i-FT-MP4ARC' },
    'h264': { IconName: 'i-FT-MP4ARC' },
    'm4v': { IconName: 'i-FT-MP4ARC' },
    'mkv': { IconName: 'i-FT-MP4ARC' },
    'mov': { IconName: 'i-FT-MP4ARC' },
    'mp4': { IconName: 'i-FT-MP4ARC' },
    'mpg': { IconName: 'i-FT-MP4ARC' },
    'mpeg': { IconName: 'i-FT-MP4ARC' },
    'rm': { IconName: 'i-FT-MP4ARC' },
    'swf': { IconName: 'i-FT-MP4ARC' },
    'vob': { IconName: 'i-FT-MP4ARC' },
    'wmv': { IconName: 'i-FT-MP4ARC' }
};
export { ExtMap };
